<template>
  <div class="container-fluid customer-media-container">
    <!-- home img
    <b-row>
      <b-col lg="2" md="5" cols="5" class="mx-auto">
       
      </b-col>
    </b-row> -->
    <!-- title -->
    <b-row class="">
      <b-col xl="6" lg="8" class="mx-auto mt-md-4 mt-3">
        <h2 class="welcomeUserHomeH2DY mb-0">Close Your Eyes and Listen</h2>
      </b-col>
    </b-row>
    <MediaSimpleCardList
      v-if="audio_playlists.length > 0"
      list_title="Audio"
      :list_items="audio_playlists"
      type="meditation_audio"
    />
    <MediaSimpleCardList
      v-if="video_playlists.length > 0"
      list_title="Visual"
      :list_items="video_playlists"
      type="meditation_video"
    />
  </div>
</template>

<script>
import MediaSimpleCardList from "@/components/media_components/MediaSimpleCardList.vue";
import axios from "axios";

export default {
  name: "DoOmYogaCustomerMeditation",
  components: { MediaSimpleCardList },
  data() {
    return {
      login_user: window.localStorage.getItem("user"),
      user_name: "",
      media_library: "meditation_library",

      audio_playlists: [],
      video_playlists: [],
    };
  },
  mounted() {
    this.getMediaCategoryList("video");
    this.getMediaCategoryList("audio");
  },
  methods: {
    getMediaCategoryList(sub_library) {
      console.log("in get categories");
      // this.category_list = [];
      let formData = new FormData();
      formData.append("media_library", this.media_library);
      formData.append("sub_library", sub_library);
      axios
        .post("media/library/categories", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data);
          if (sub_library == "audio") {
            this.audio_playlists = response.data;
          } else if (sub_library == "video") {
            this.video_playlists = response.data;
          }
        });
    },
  },
};
</script>

<style scoped::v-deep >
</style>


// WEBPACK FOOTER //
// src/components/doom_yoga/customer/Meditation/Index.vue